<template>
  <!-- eslint-disable vue/no-v-html -->
  <LandingPageLayout :page-color="false">
    <div class="banner">
      <div class="wrapper">
        <div class="inner">
          <div class="left">
            <div class="caption">
              <div ref="titleBanner" class="title">
                <h1>
                  <div v-html="t('lp.recruiter.title_html')"></div>
                </h1>
              </div>
              <div ref="detailsBanner" class="details">
                <p>
                  {{ t('lp.recruiter.description') }}
                </p>
              </div>
            </div>
            <div ref="btnGroupBanner" class="btn-group">
              <a href="/recruiter_applications/new">
                {{ t('lp.recruiter.btn') }}</a
              >
            </div>
          </div>
          <div class="right">
            <div ref="imgBanner" class="img">
              <img
                :src="require('images/views/lp/recruiter/banner-recruiter.jpg')"
                alt="Banner for Recruiter page"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="choose-sourcedout">
      <div class="wrapper">
        <div class="inner">
          <div class="title">
            <h2>{{ t('lp.recruiter.why_choose_sourcedout.title') }}</h2>
          </div>
          <div ref="chooseSourcedout" class="main">
            <ul class="list">
              <li class="item">
                <div class="icon">
                  <lottie
                    :options="rc01Options"
                    :height="100"
                    :width="100"
                    @v-on:animCreated="handleAnimation"
                  />
                </div>
                <div ref="itemOne" class="content">
                  <div class="heading">
                    <h3>
                      {{
                        t(
                          'lp.recruiter.why_choose_sourcedout.list.high_earning_awaits.title'
                        )
                      }}
                    </h3>
                  </div>
                  <div class="text">
                    {{
                      t(
                        'lp.recruiter.why_choose_sourcedout.list.high_earning_awaits.details'
                      )
                    }}
                  </div>
                </div>
              </li>
              <li class="item">
                <div class="icon">
                  <lottie
                    :options="rc02Options"
                    :height="100"
                    :width="100"
                    @v-on:animCreated="handleAnimation"
                  />
                </div>
                <div ref="itemTwo" class="content">
                  <div class="heading">
                    <h3>
                      {{
                        t(
                          'lp.recruiter.why_choose_sourcedout.list.work_it_on_your_way.title'
                        )
                      }}
                    </h3>
                  </div>
                  <div class="text">
                    {{
                      t(
                        'lp.recruiter.why_choose_sourcedout.list.work_it_on_your_way.details'
                      )
                    }}
                  </div>
                </div>
              </li>
              <li class="item">
                <div class="icon">
                  <lottie
                    :options="rc03Options"
                    :height="100"
                    :width="100"
                    @v-on:animCreated="handleAnimation"
                  />
                </div>
                <div ref="itemThree" class="content">
                  <div class="heading">
                    <h3>
                      {{
                        t(
                          'lp.recruiter.why_choose_sourcedout.list.fresh_opportunities.title'
                        )
                      }}
                    </h3>
                  </div>
                  <div class="text">
                    {{
                      t(
                        'lp.recruiter.why_choose_sourcedout.list.fresh_opportunities.details'
                      )
                    }}
                  </div>
                </div>
              </li>
              <li class="item">
                <div class="icon">
                  <lottie
                    :options="rc04Options"
                    :height="100"
                    :width="100"
                    @v-on:animCreated="handleAnimation"
                  />
                </div>
                <div ref="itemFour" class="content">
                  <div class="heading">
                    <h3>
                      {{
                        t(
                          'lp.recruiter.why_choose_sourcedout.list.support_by_professional_team.title'
                        )
                      }}
                    </h3>
                  </div>
                  <div class="text">
                    {{
                      t(
                        'lp.recruiter.why_choose_sourcedout.list.support_by_professional_team.details'
                      )
                    }}
                  </div>
                </div>
              </li>
              <li class="item">
                <div class="icon">
                  <lottie
                    :options="rc05Options"
                    :height="100"
                    :width="100"
                    @v-on:animCreated="handleAnimation"
                  />
                </div>
                <div ref="itemFive" class="content">
                  <div class="heading">
                    <h3>
                      {{
                        t(
                          'lp.recruiter.why_choose_sourcedout.list.talent_pool_access.title'
                        )
                      }}
                    </h3>
                  </div>
                  <div class="text">
                    {{
                      t(
                        'lp.recruiter.why_choose_sourcedout.list.talent_pool_access.details'
                      )
                    }}
                  </div>
                </div>
              </li>
              <li class="item">
                <div class="icon">
                  <lottie
                    :options="rc06Options"
                    :height="100"
                    :width="100"
                    @v-on:animCreated="handleAnimation"
                  />
                </div>
                <div ref="itemSix" class="content">
                  <div class="heading">
                    <h3>
                      {{
                        t(
                          'lp.recruiter.why_choose_sourcedout.list.we_got_you.title'
                        )
                      }}
                    </h3>
                  </div>
                  <div class="text">
                    {{
                      t(
                        'lp.recruiter.why_choose_sourcedout.list.we_got_you.details'
                      )
                    }}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div ref="earn" class="earn">
      <div class="wrapper">
        <div class="inner">
          <div class="main">
            <div class="left">
              <div ref="imgEarn" class="img">
                <img
                  :src="
                    require('images/views/lp/recruiter/earn/recruiter-phone.png')
                  "
                  alt="How Much Can I Earn?"
                />
              </div>
            </div>
            <div ref="contentEarn" class="right">
              <div class="title">
                <h2>{{ t('lp.recruiter.how_much_can_i_earn.title') }}</h2>
              </div>
              <div
                class="text"
                v-html="t('lp.recruiter.how_much_can_i_earn.description_html')"
              ></div>
              <div class="btn">
                <a href="/recruiter_applications/new">{{
                  t('lp.recruiter.how_much_can_i_earn.btn')
                }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sourcedout-insight">
      <div class="wrapper">
        <div class="inner">
          <div ref="titleInsight" class="title">
            <h2>{{ t('lp.recruiter.sourcedout_insight.title') }}</h2>
          </div>
          <div class="main">
            <ul class="list">
              <li class="item">
                <div class="number">
                  <ICountUp
                    :delay="delay"
                    :end-val="no_clients"
                    :options="options_count"
                  />
                  +
                </div>
                <div class="text">
                  {{ t('lp.recruiter.sourcedout_insight.number_of_clients') }}
                </div>
              </li>
              <li class="item">
                <div class="number">
                  <ICountUp
                    :delay="delay"
                    :end-val="no_jobs"
                    :options="options_count"
                  />
                  +
                </div>
                <div class="text">
                  {{ t('lp.recruiter.sourcedout_insight.opening_jobs') }}
                </div>
              </li>
              <li class="item">
                <div class="number">
                  <ICountUp
                    :delay="delay"
                    :end-val="avg_earning"
                    :options="options_count"
                  />
                  ฿
                </div>
                <div class="text">
                  {{
                    t('lp.recruiter.sourcedout_insight.placement_incentives')
                  }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div ref="experienced" class="experienced-recruiter">
      <div class="wrapper">
        <div class="inner">
          <div class="main">
            <div ref="contentExperienced" class="left">
              <div class="title">
                <h2>{{ t('lp.recruiter.experienced_recruiter.title') }}</h2>
              </div>
              <ul class="benefits">
                <li>
                  <span class="check">
                    <i class="las la-check"></i>
                  </span>
                  <span>{{
                    t('lp.recruiter.experienced_recruiter.benefits.first')
                  }}</span>
                </li>
                <li>
                  <span class="check">
                    <i class="las la-check"></i>
                  </span>
                  <span>{{
                    t('lp.recruiter.experienced_recruiter.benefits.second')
                  }}</span>
                </li>
              </ul>
              <div class="btn">
                <a href="/recruiter_applications/new">{{
                  t('lp.recruiter.experienced_recruiter.btn')
                }}</a>
              </div>
            </div>
            <div ref="imgExperienced" class="right">
              <div class="img">
                <img
                  :src="
                    currentLocale() === 'th'
                      ? require('images/views/lp/recruiter/experienced/experienced-recruiter-th.jpg')
                      : require('images/views/lp/recruiter/experienced/experienced-recruiter-en.jpg')
                  "
                  alt="Experienced Recruiter? Let's Talk!"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="steps">
      <div class="wrapper">
        <div class="inner">
          <div ref="titleSteps" class="title">
            <h2>{{ t('lp.recruiter.steps.title') }}</h2>
          </div>
          <div class="main">
            <ul class="list">
              <li class="item">
                <div ref="registerStep">
                  <div class="icon">
                    <img
                      :src="
                        require('images/views/lp/recruiter/steps/rc-step01.png')
                      "
                      alt="Steps"
                    />
                  </div>
                  <div class="content">
                    <div class="heading">
                      <h3>{{ t('lp.recruiter.steps.list.register.title') }}</h3>
                    </div>
                    <div class="text">
                      {{ t('lp.recruiter.steps.list.register.details') }}
                    </div>
                  </div>
                </div>
              </li>
              <li class="item">
                <div ref="reviewStep">
                  <div class="icon">
                    <img
                      :src="
                        require('images/views/lp/recruiter/steps/rc-step02.png')
                      "
                      alt="Steps"
                    />
                  </div>
                  <div class="content">
                    <div class="heading">
                      <h3>{{ t('lp.recruiter.steps.list.review.title') }}</h3>
                    </div>
                    <div class="text">
                      {{ t('lp.recruiter.steps.list.review.details') }}
                    </div>
                  </div>
                </div>
              </li>
              <li class="item">
                <div ref="createStep">
                  <div class="icon">
                    <img
                      :src="
                        require('images/views/lp/recruiter/steps/rc-step03.png')
                      "
                      alt="Steps"
                    />
                  </div>
                  <div class="content">
                    <div class="heading">
                      <h3>{{ t('lp.recruiter.steps.list.create.title') }}</h3>
                    </div>
                    <div class="text">
                      {{ t('lp.recruiter.steps.list.create.details') }}
                    </div>
                  </div>
                </div>
              </li>
              <li class="item">
                <div ref="startStep">
                  <div class="icon">
                    <img
                      :src="
                        require('images/views/lp/recruiter/steps/rc-step04.png')
                      "
                      alt="Steps"
                    />
                  </div>
                  <div class="content">
                    <div class="heading">
                      <h3>{{ t('lp.recruiter.steps.list.start.details') }}</h3>
                    </div>
                    <div class="text">
                      {{ t('lp.recruiter.steps.list.start.details') }}
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="join">
      <div class="wrapper">
        <div class="inner">
          <div class="title">
            <h2>{{ t('lp.recruiter.make_a_start.title') }}</h2>
          </div>
          <div class="text-top">
            {{ t('lp.recruiter.make_a_start.description') }}
          </div>
          <div class="main">
            <div class="tabs">
              <div class="content">
                <div class="description">
                  {{ t('lp.recruiter.make_a_start.description') }}
                </div>
                <ul ref="content" class="list">
                  <li
                    class="item active selection"
                    @click="select('selection')"
                  >
                    <div class="number">1</div>
                    <div class="details">
                      <div class="heading">
                        <h3>
                          {{
                            t(
                              'lp.recruiter.make_a_start.list.job_selection.title'
                            )
                          }}
                        </h3>
                      </div>
                      <div class="text">
                        {{
                          t(
                            'lp.recruiter.make_a_start.list.job_selection.details'
                          )
                        }}
                      </div>
                    </div>
                  </li>
                  <li class="item sourcing" @click="select('sourcing')">
                    <div class="number">2</div>
                    <div class="details">
                      <div class="heading">
                        <h3>
                          {{
                            t(
                              'lp.recruiter.make_a_start.list.sourcing_screening.title'
                            )
                          }}
                        </h3>
                      </div>
                      <div class="text">
                        {{
                          t(
                            'lp.recruiter.make_a_start.list.sourcing_screening.details'
                          )
                        }}
                      </div>
                    </div>
                  </li>
                  <li class="item submit" @click="select('submit')">
                    <div class="number">3</div>
                    <div class="details">
                      <div class="heading">
                        <h3>
                          {{
                            t(
                              'lp.recruiter.make_a_start.list.submit_candidate.title'
                            )
                          }}
                        </h3>
                      </div>
                      <div class="text">
                        {{
                          t(
                            'lp.recruiter.make_a_start.list.submit_candidate.details'
                          )
                        }}
                      </div>
                    </div>
                  </li>
                  <li class="item rewards" @click="select('rewards')">
                    <div class="number">4</div>
                    <div class="details">
                      <div class="heading">
                        <h3>
                          {{
                            t('lp.recruiter.make_a_start.list.rewards.title')
                          }}
                        </h3>
                      </div>
                      <div class="text">
                        {{
                          t('lp.recruiter.make_a_start.list.rewards.details')
                        }}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div ref="image" class="img">
                <div class="img-item active selection">
                  <img
                    :src="
                      require('images/views/lp/recruiter/join/step-screen-1.png')
                    "
                    alt="Steps Screen"
                  />
                </div>
                <div class="img-item sourcing">
                  <img
                    :src="
                      require('images/views/lp/recruiter/join/step-screen-2.png')
                    "
                    alt="Steps Screen"
                  />
                </div>
                <div class="img-item submit">
                  <img
                    :src="
                      require('images/views/lp/recruiter/join/step-screen-3.png')
                    "
                    alt="Steps Screen"
                  />
                </div>
                <div class="img-item rewards">
                  <img
                    :src="
                      require('images/views/lp/recruiter/join/step-screen-4.png')
                    "
                    alt="Steps Screen"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="btn"></div>
        </div>
      </div>
    </div>
    <div ref="review" class="review">
      <div class="wrapper">
        <div class="inner">
          <div ref="titleReview" class="title">
            <h2>{{ t('lp.recruiter.what_they_say.title') }}</h2>
          </div>
          <div ref="slider" class="slider">
            <div>
              <Flicking
                :options="{ align: 'prev', circular: true }"
                :plugins="plugins_review"
              >
                <div class="container">
                  <div>
                    <div class="details">
                      <div
                        v-if="
                          t('lp.recruiter.what_they_say.list.wanida.header')
                        "
                        class="header"
                      >
                        {{ t('lp.recruiter.what_they_say.list.wanida.header') }}
                      </div>
                      <div class="text">
                        <p>
                          {{ t('lp.recruiter.what_they_say.list.wanida.text') }}
                        </p>
                      </div>
                    </div>
                    <div class="author">
                      <div class="logo">
                        <div class="img">
                          <img
                            :src="
                              require('images/views/lp/recruiter/profile/profile-f.png')
                            "
                            alt="profile"
                          />
                        </div>
                      </div>
                      <div class="client">
                        <div class="name">
                          {{ t('lp.recruiter.what_they_say.list.wanida.name') }}
                        </div>
                        <div class="position">
                          {{
                            t('lp.recruiter.what_they_say.list.wanida.position')
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="container">
                  <div>
                    <div class="details">
                      <div
                        v-if="
                          t('lp.recruiter.what_they_say.list.sunanta.header')
                        "
                        class="header"
                      >
                        {{
                          t('lp.recruiter.what_they_say.list.sunanta.header')
                        }}
                      </div>
                      <div class="text">
                        <p>
                          {{
                            t('lp.recruiter.what_they_say.list.sunanta.text')
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="author">
                      <div class="logo">
                        <div class="img">
                          <img
                            :src="
                              require('images/views/lp/recruiter/profile/profile-f.png')
                            "
                            alt="profile"
                          />
                        </div>
                      </div>
                      <div class="client">
                        <div class="name">
                          {{
                            t('lp.recruiter.what_they_say.list.sunanta.name')
                          }}
                        </div>
                        <div class="position">
                          {{
                            t(
                              'lp.recruiter.what_they_say.list.sunanta.position'
                            )
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="container">
                  <div>
                    <div class="details">
                      <div
                        v-if="
                          t('lp.recruiter.what_they_say.list.vachiraya.header')
                        "
                        class="header"
                      >
                        {{
                          t('lp.recruiter.what_they_say.list.vachiraya.header')
                        }}
                      </div>
                      <div class="text">
                        <p>
                          {{
                            t('lp.recruiter.what_they_say.list.vachiraya.text')
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="author">
                      <div class="logo">
                        <div class="img">
                          <img
                            :src="
                              require('images/views/lp/recruiter/profile/profile-f.png')
                            "
                            alt="profile"
                          />
                        </div>
                      </div>
                      <div class="client">
                        <div class="name">
                          {{
                            t('lp.recruiter.what_they_say.list.vachiraya.name')
                          }}
                        </div>
                        <div class="position">
                          {{
                            t(
                              'lp.recruiter.what_they_say.list.vachiraya.position'
                            )
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="container">
                  <div>
                    <div class="details">
                      <div
                        v-if="
                          t('lp.recruiter.what_they_say.list.chatchai.header')
                        "
                        class="header"
                      >
                        {{
                          t('lp.recruiter.what_they_say.list.chatchai.header')
                        }}
                      </div>
                      <div class="text">
                        <p>
                          {{
                            t('lp.recruiter.what_they_say.list.chatchai.text')
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="author">
                      <div class="logo">
                        <div class="img">
                          <img
                            :src="
                              require('images/views/lp/recruiter/profile/profile-m.png')
                            "
                            alt="profile"
                          />
                        </div>
                      </div>
                      <div class="client">
                        <div class="name">
                          {{
                            t('lp.recruiter.what_they_say.list.chatchai.name')
                          }}
                        </div>
                        <div class="position">
                          {{
                            t(
                              'lp.recruiter.what_they_say.list.chatchai.position'
                            )
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div slot="viewport" class="flicking-pagination"></div>
                <div slot="viewport">
                  <span class="flicking-arrow-prev is-circle">
                    <FontAwesomeIcon
                      :icon="{ prefix: 'fas', iconName: 'angle-left' }"
                    ></FontAwesomeIcon>
                  </span>
                  <span class="flicking-arrow-next is-circle">
                    <FontAwesomeIcon
                      :icon="{ prefix: 'fas', iconName: 'angle-right' }"
                    ></FontAwesomeIcon>
                  </span>
                </div>
              </Flicking>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="faq" class="faq">
      <div class="wrapper">
        <div class="inner">
          <div ref="titleFaq" class="title">
            <h2>FAQ</h2>
          </div>
          <div ref="faq_container">
            <sui-accordion exclusive>
              <div class="main">
                <sui-accordion-title>
                  <h3>{{ t('lp.recruiter.faq.one.question') }}</h3>
                  <div class="button">
                    <i class="las la-plus"></i>
                  </div>
                </sui-accordion-title>
                <sui-accordion-content>
                  <div v-html="t('lp.recruiter.faq.one.answer_html')"></div>
                </sui-accordion-content>
              </div>
              <div class="main">
                <sui-accordion-title>
                  <h3>
                    {{ t('lp.recruiter.faq.two.question') }}
                  </h3>
                  <div class="button">
                    <i class="las la-plus"></i>
                  </div>
                </sui-accordion-title>
                <sui-accordion-content>
                  <div v-html="t('lp.recruiter.faq.two.answer_html')"></div>
                </sui-accordion-content>
              </div>
              <div class="main">
                <sui-accordion-title>
                  <h3>
                    {{ t('lp.recruiter.faq.three.question') }}
                  </h3>
                  <div class="button">
                    <i class="las la-plus"></i>
                  </div>
                </sui-accordion-title>
                <sui-accordion-content>
                  <div v-html="t('lp.recruiter.faq.three.answer_html')"></div>
                </sui-accordion-content>
              </div>
              <div class="main">
                <sui-accordion-title>
                  <h3>
                    {{ t('lp.recruiter.faq.four.question') }}
                  </h3>
                  <div class="button">
                    <i class="las la-plus"></i>
                  </div>
                </sui-accordion-title>
                <sui-accordion-content>
                  <div v-html="t('lp.recruiter.faq.four.answer_html')"></div>
                </sui-accordion-content>
              </div>
              <div class="main">
                <sui-accordion-title>
                  <h3>
                    {{ t('lp.recruiter.faq.five.question') }}
                  </h3>
                  <div class="button">
                    <i class="las la-plus"></i>
                  </div>
                </sui-accordion-title>
                <sui-accordion-content>
                  <div v-html="t('lp.recruiter.faq.five.answer_html')"></div>
                </sui-accordion-content>
              </div>
            </sui-accordion>
          </div>
        </div>
      </div>
    </div>
  </LandingPageLayout>
  <!-- eslint-enable vue/no-v-html -->
</template>
<script>
import Vue from 'vue'
import LandingPageLayout from 'components/layouts/LandingPage.vue'

import SuiVue from 'semantic-ui-vue'
Vue.use(SuiVue)

import { Flicking } from '@egjs/vue-flicking'
import '@egjs/flicking/dist/flicking.css'
import { Pagination, AutoPlay, Arrow } from '@egjs/flicking-plugins'
import '@egjs/flicking-plugins/dist/pagination.css'
import '@egjs/flicking-plugins/dist/arrow.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleRight, faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faAngleRight)
library.add(faAngleLeft)

import Lottie from 'vue-lottie'
import * as rc01 from '../../../images/views/lp/recruiter/lottie/rc01.json'
import * as rc02 from '../../../images/views/lp/recruiter/lottie/rc02.json'
import * as rc03 from '../../../images/views/lp/recruiter/lottie/rc03.json'
import * as rc04 from '../../../images/views/lp/recruiter/lottie/rc04.json'
import * as rc05 from '../../../images/views/lp/recruiter/lottie/rc05.json'
import * as rc06 from '../../../images/views/lp/recruiter/lottie/rc06.json'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

import ICountUp from 'vue-countup-v2'

import I18n from 'i18n/i18n'
import 'i18n/views/lp/en'
import 'i18n/views/lp/th'
import { i18n } from 'mixins/i18n'
window.I18n = I18n

export default {
  name: 'Recruiter',

  components: {
    LandingPageLayout,
    Flicking,
    FontAwesomeIcon,
    lottie: Lottie,
    ICountUp,
  },
  mixins: [i18n],

  data() {
    return {
      delay: 1000,
      no_clients: 1000,
      no_jobs: 200,
      avg_earning: 12000,
      options_count: {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: '.',
        prefix: '',
        suffix: '',
        enableScrollSpy: true,
      },
      rc01Options: { animationData: rc01.default },
      rc02Options: { animationData: rc02.default },
      rc03Options: { animationData: rc03.default },
      rc04Options: { animationData: rc04.default },
      rc05Options: { animationData: rc05.default },
      rc06Options: { animationData: rc06.default },
      animationSpeed: 1,
      plugins_review: [
        new Arrow(),
        new AutoPlay({ duration: 3000, direction: 'NEXT', stopOnHover: false }),
        new Pagination({ type: 'bullet' }),
      ],
      options: {
        autoplay: true,
      },
    }
  },

  mounted() {
    gsap.fromTo(
      this.$refs.titleBanner,
      { duration: 0.7, x: -1000, opacity: 0 },
      { duration: 0.7, x: 0, opacity: 1 }
    )
    gsap.fromTo(
      this.$refs.imgBanner,
      { duration: 0.9, x: 1000 },
      { duration: 0.9, x: 0 }
    )
    gsap.fromTo(
      this.$refs.detailsBanner,
      { duration: 1, x: -1000, opacity: 0 },
      { duration: 1, x: 0, opacity: 1 }
    )
    gsap.fromTo(
      this.$refs.btnGroupBanner,
      { duration: 1.9, opacity: 0 },
      { duration: 1.9, opacity: 1 }
    )

    let choose_sourcedout_section = gsap.timeline()

    ScrollTrigger.create({
      trigger: this.$refs.chooseSourcedout,
      start: 'top 90%',
      end: 'bottom 30%',
      animation: choose_sourcedout_section,
      toggleActions: 'play none none none',
    })

    choose_sourcedout_section
      .fromTo(
        this.$refs.itemOne,
        { y: 20, opacity: 0, duration: 0.4 },
        { y: 0, opacity: 1, duration: 0.4 }
      )
      .fromTo(
        this.$refs.itemTwo,
        { y: 20, opacity: 0, duration: 0.4 },
        { y: 0, opacity: 1, duration: 0.4 }
      )
      .fromTo(
        this.$refs.itemThree,
        { y: 20, opacity: 0, duration: 0.4 },
        { y: 0, opacity: 1, duration: 0.4 }
      )
      .fromTo(
        this.$refs.itemFour,
        { y: 20, opacity: 0, duration: 0.4 },
        { y: 0, opacity: 1, duration: 0.4 }
      )
      .fromTo(
        this.$refs.itemFive,
        { y: 20, opacity: 0, duration: 0.4 },
        { y: 0, opacity: 1, duration: 0.4 }
      )
      .fromTo(
        this.$refs.itemSix,
        { y: 20, opacity: 0, duration: 0.4 },
        { y: 0, opacity: 1, duration: 0.4 }
      )

    let earn_section = gsap.timeline()

    ScrollTrigger.create({
      trigger: this.$refs.earn,
      start: 'top 90%',
      end: 'bottom 30%',
      animation: earn_section,
      toggleActions: 'play none none none',
    })

    earn_section
      .fromTo(
        this.$refs.imgEarn,
        { y: 80, opacity: 0, duration: 0.5 },
        { y: 0, opacity: 1, duration: 0.5 },
        0.5
      )
      .fromTo(
        this.$refs.contentEarn,
        { x: 500, opacity: 0, duration: 0.6 },
        { x: 0, opacity: 1, duration: 0.6 },
        0.5
      )
      .fromTo(
        this.$refs.contentEarn,
        { x: 500, opacity: 0, duration: 0.7 },
        { x: 0, opacity: 1, duration: 0.7 },
        0.5
      )

    let experienced_section = gsap.timeline()

    ScrollTrigger.create({
      trigger: this.$refs.experienced,
      start: 'top 90%',
      end: 'bottom 30%',
      animation: experienced_section,
      toggleActions: 'play none none none',
    })

    experienced_section
      .fromTo(
        this.$refs.contentExperienced,
        { x: -500, opacity: 0, duration: 0.9 },
        { x: 0, opacity: 1, duration: 0.9 },
        0.5
      )
      .fromTo(
        this.$refs.imgExperienced,
        { x: 500, opacity: 0, duration: 0.9 },
        { x: 0, opacity: 1, duration: 0.9 },
        0.5
      )

    let steps = gsap.timeline()

    ScrollTrigger.create({
      trigger: this.$refs.titleSteps,
      start: 'top 90%',
      end: 'bottom 30%',
      animation: steps,
      toggleActions: 'play none none none',
    })

    steps
      .fromTo(
        this.$refs.registerStep,
        { y: 20, opacity: 0, duration: 0.3 },
        { y: 0, opacity: 1, duration: 0.3 }
      )
      .fromTo(
        this.$refs.reviewStep,
        { y: 20, opacity: 0, duration: 0.3 },
        { y: 0, opacity: 1, duration: 0.3 }
      )
      .fromTo(
        this.$refs.createStep,
        { y: 20, opacity: 0, duration: 0.3 },
        { y: 0, opacity: 1, duration: 0.3 }
      )
      .fromTo(
        this.$refs.startStep,
        { y: 20, opacity: 0, duration: 0.3 },
        { y: 0, opacity: 1, duration: 0.3 }
      )

    let review_section = gsap.timeline()

    ScrollTrigger.create({
      trigger: this.$refs.review,
      start: 'top 80%',
      end: 'bottom 30%',
      animation: review_section,
      toggleActions: 'play none none none',
    })

    review_section.fromTo(
      this.$refs.slider,
      { y: 100, opacity: 0, duration: 1.2 },
      { y: 0, opacity: 1, duration: 1.2 }
    )

    let faq_section = gsap.timeline()

    ScrollTrigger.create({
      trigger: this.$refs.faq,
      start: 'top 90%',
      end: 'bottom 30%',
      animation: faq_section,
      toggleActions: 'play none none none',
    })

    faq_section
      .fromTo(
        this.$refs.titleFaq,
        { y: 100, opacity: 0, duration: 0.4 },
        { y: 0, opacity: 1, duration: 0.4 },
        0.5
      )
      .fromTo(
        this.$refs.faq_container,
        { y: 100, opacity: 0, duration: 0.5 },
        { y: 0, opacity: 1, duration: 0.5 },
        0.5
      )
  },

  methods: {
    handleAnimation: function (anim) {
      this.anim = anim
    },
    select(ref) {
      Object.keys(this.$refs.content.children).forEach((index) => {
        if (this.$refs.content.children[index].classList.contains(ref)) {
          this.$refs.content.children[index].classList.add('active')
        } else {
          this.$refs.content.children[index].classList.contains('active') &&
            this.$refs.content.children[index].classList.remove('active')
        }
      })

      Object.keys(this.$refs.image.children).forEach((index) => {
        if (this.$refs.image.children[index].classList.contains(ref)) {
          this.$refs.image.children[index].classList.add('active')
        } else if (
          this.$refs.image.children[index].classList.contains('active')
        ) {
          this.$refs.image.children[index].classList.remove('active')
        }
      })
    },
  },
}
</script>
<style scoped lang="scss">
@import 'stylesheets/global';
@import url('https://use.fontawesome.com/releases/v5.13.0/css/all.css');

.banner {
  background-color: $white;
  position: relative;

  .wrapper {
    flex: auto;
    margin: auto;
    max-width: 80%;
    padding: 0 2rem;
    width: auto;

    @include sp {
      max-width: unset;
      padding: 0;
    }

    .inner {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      height: auto;
      padding: 5rem 0;
      width: 100%;

      @include sp {
        padding: 0;
      }
    }
  }

  @include sp {
    padding-bottom: 2rem;
  }

  h1 {
    font-size: 4rem;
    font-weight: 500;
  }

  h1,
  p {
    color: $black;
  }

  .right {
    display: flex;
    justify-content: end;
    padding-top: 2rem;
    position: absolute;
    right: 0;
    width: 30%;

    @include sp {
      padding: 0;
      position: relative;
    }
  }

  .img {
    border-left: 40px solid #5080c1;
    height: 500px;
    position: relative;
    width: 450px;
    z-index: 2;

    @include sp {
      height: 400px;
      width: 60%;
      z-index: 1;
    }

    img {
      height: 100%;
      object-fit: cover;
      object-position: 65% 0;
      width: 100%;
    }
  }

  .left {
    align-self: center;
    margin: 4rem 0;
    padding-top: 2rem;
    width: 70%;

    @include sp {
      margin: auto;
      max-width: 90%;
      padding: 0;
    }

    .caption {
      align-items: flex-start;
      display: flex;
      flex-direction: column;

      @include sp {
        background: white;
        margin-top: -5rem;
        position: relative;
        width: 90%;
        z-index: 2;
      }
    }

    .details {
      margin-top: 2rem;

      p {
        font-size: 1.25em;
        line-height: 2rem;
      }

      span {
        font-weight: 600;
      }
    }
  }

  .btn-group {
    margin-top: 2rem;

    a {
      background-color: #5080c1;
      border-radius: 10rem;
      color: $white;
      font-weight: 500;
      padding: 1.5rem 2rem;
      text-align: center;
      width: 19rem;

      &:hover {
        filter: contrast(150%);
      }
    }
  }
}

.choose-sourcedout {
  overflow: hidden;
  .wrapper {
    flex: auto;
    margin: auto;
    max-width: 80%;
    padding: 0 2rem;
    width: auto;

    @include sp {
      max-width: 90%;
      padding: 0;
    }

    .inner {
      padding: 5rem 0;
    }
  }

  .title {
    margin-bottom: 1.5rem;

    h2 {
      color: $black;
      font-size: 2.5em;

      @include sp {
        font-size: 1.75em;
      }
    }
  }

  .main {
    margin-top: 10rem;

    @include sp {
      margin-top: 3rem;
    }

    .list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      > li {
        margin-bottom: 3rem;
        padding-right: 2rem;
        width: 33.33%;

        @include sp {
          align-items: center;
          display: flex;
          padding: 0;
          width: 100%;
        }
      }
    }

    .heading {
      margin-bottom: 1.25rem;

      h3 {
        color: $black;
        font-size: 1.5em;
        font-weight: 500;
        letter-spacing: 1px;
      }
    }

    .text {
      font-size: 1.2em;
      line-height: 2rem;
    }
  }

  .icon {
    height: 100px;
    margin-bottom: 1.25rem;
    width: 100px;

    img {
      height: 100px;
      width: 100px;

      @include sp {
        height: 90px;
        width: 90px;
      }
    }

    @include sp {
      margin-bottom: 0;
      margin-right: 2rem;
    }
  }
}

.earn {
  background-color: #f6f9fc;
  overflow: hidden;

  .wrapper {
    flex: auto;
    margin: auto;
    max-width: 80%;
    padding: 0 2rem;
    width: auto;

    @include sp {
      max-width: 90%;
      padding: 0;
    }

    .inner {
      padding: 0;
    }
  }

  .title {
    margin-bottom: 1.5rem;

    h2 {
      color: $black;
      font-size: 2.5em;

      @include sp {
        font-size: 1.75em;
      }
    }
  }

  .main {
    align-items: center;
    display: flex;
    flex-direction: row;
    padding-top: 3rem;

    @include sp {
      flex-direction: column;
    }

    > div {
      width: 50%;

      @include sp {
        width: 100%;
      }
    }

    .left {
      align-self: flex-end;

      @include sp {
        align-self: center;
      }
    }

    .right {
      padding: 3rem 0;

      .btn {
        font-size: 1.15em;
        margin-top: 2rem;
        padding: 0;

        @include sp {
          width: 100%;
        }

        a {
          background-color: #5080c1;
          border-radius: 10rem;
          color: $white;
          font-weight: 500;
          padding: 1.5rem 2rem;
          text-align: center;
          width: 20rem;

          @include sp {
            width: auto;
          }

          &:hover {
            filter: contrast(150%);
          }
        }
      }
    }

    .img {
      @include sp {
        display: flex;
        justify-content: center;
        margin-left: -3rem;
      }

      img {
        float: left;
        height: 100%;
        object-fit: cover;
        transform: translate3d(0, 0, 0);
        width: 35vw;

        @include sp {
          width: 450px;
        }
      }
    }

    /* stylelint-disable no-descending-specificity */
    ::v-deep .text {
      > p {
        color: $black;
        font-size: 1.2em;
        line-height: 2rem;
        margin-bottom: 1rem;

        @include sp {
          font-size: 1em;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    /* stylelint-enable no-descending-specificity */
  }
}

.sourcedout-insight {
  .wrapper {
    flex: auto;
    margin: auto;
    max-width: 80%;
    padding: 0 2rem;
    width: auto;

    @include sp {
      max-width: 90%;
      padding: 0;
    }

    .inner {
      padding: 5rem 0;
    }
  }

  .title {
    margin-bottom: 3rem;

    h2 {
      color: $black;
      font-size: 2.5em;

      @include sp {
        font-size: 1.75em;
      }
    }
  }

  .main {
    .list {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      @include sp {
        flex-direction: column;
      }

      > li {
        flex: 1 1 0;
        text-align: center;

        @include sp {
          margin-bottom: 3rem;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    .number {
      color: #5080c1;
      font-size: 3em;
      font-weight: 600;
      line-height: 5rem;
    }

    /* stylelint-disable no-descending-specificity */
    .text {
      font-size: 1.2em;
      font-weight: 500;

      @include sp {
        font-size: 1em;
      }
    }
    /* stylelint-enable no-descending-specificity */
  }
}

.experienced-recruiter {
  overflow: hidden;

  .wrapper {
    flex: auto;
    margin: auto;
    max-width: 80%;
    padding: 0 2rem;
    width: auto;

    @include sp {
      max-width: 90%;
      padding: 0;
    }

    .inner {
      padding: 5rem 0;
    }
  }

  .title h2 {
    color: $black;
    font-size: 2.5em;
    font-weight: 700;

    @include sp {
      font-size: 1.75em;
    }
  }

  .check {
    align-items: center;
    background-color: #5080c1;
    border-radius: 50%;
    color: $white;
    display: flex;
    flex-shrink: 0;
    height: 28px;
    justify-content: center;
    margin-right: 1rem;
    width: 28px;

    i {
      font-size: 1rem;
    }
  }

  .main {
    align-items: stretch;
    display: flex;
    flex-direction: row;
    gap: 2rem;

    @include sp {
      flex-direction: column;
    }

    > .left,
    > .right {
      width: 50%;

      @include sp {
        width: 100%;
      }
    }

    > .right {
      @include sp {
        order: -1;
      }
    }

    .left {
      background-color: #e8f0fe;
      border-radius: 32px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 3.5rem;

      @include sp {
        padding: 2rem;
      }

      .btn {
        font-size: 1.15em;
        margin-top: 2.5rem;
        padding: 0;
        text-align: left;

        /* stylelint-disable-next-line no-descending-specificity */
        a {
          background-color: #5080c1;
          border-radius: 10rem;
          color: $white;
          display: inline-block;
          font-weight: 500;
          padding: 1.25rem 2.5rem;
          text-align: center;

          @include sp {
            width: 100%;
          }

          &:hover {
            filter: contrast(150%);
          }
        }
      }
    }

    .benefits {
      display: flex;
      flex-direction: column;
      gap: 1.25rem;
      margin-top: 2rem;

      li {
        align-items: center;
        display: flex;
        font-size: 1.05em;
        font-weight: 400;

        @include sp {
          font-size: 0.95em;
        }
      }
    }

    .img {
      border-radius: 32px;
      height: 100%;
      overflow: hidden;

      img {
        display: block;
        height: 100%;
        object-fit: cover;
        width: 100%;
      }
    }
  }
}

.steps {
  background-color: #f6f9fc;

  .wrapper {
    flex: auto;
    margin: auto;
    max-width: 80%;
    padding: 0 2rem;
    width: auto;

    @include sp {
      max-width: 90%;
      padding: 0;
    }

    .inner {
      padding: 5rem 0;
    }
  }

  .title {
    margin-bottom: 1.5rem;

    h2 {
      color: $black;
      font-size: 2.5em;

      @include sp {
        font-size: 1.75em;
      }
    }
  }

  .main {
    .list {
      display: flex;
      justify-content: space-between;

      > li {
        position: relative;
        width: 20%;

        > div {
          @include sp {
            display: flex;
            justify-content: space-between;
            width: 100%;
          }
        }

        &::after {
          color: #7b95df;
          content: '\f0da';
          /* stylelint-disable font-family-no-missing-generic-family-keyword */
          font-family: 'Font Awesome 5 Free';
          /* stylelint-disable-next-linedeclaration-no-important */
          font-size: 2.5em;
          font-style: normal;
          font-weight: 900;
          position: absolute;
          right: -2rem;
          top: 6rem;
        }

        &:last-child {
          &::after {
            content: none;
          }
        }
      }

      .heading {
        h3 {
          color: #1a1a1a;
          font-size: 1.5em;
          font-weight: 600;
          letter-spacing: 1px;
        }
      }

      .text {
        font-size: 1.2em;
        font-weight: 500;
        line-height: 2rem;
        margin-top: 1rem;

        @include sp {
          font-size: 1em;
        }
      }
    }

    .icon {
      background-color: $white;
      border-radius: 100rem;
      height: 180px;
      margin-bottom: 1.5rem;
      position: relative;
      width: 180px;

      img {
        height: auto;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}

.join {
  .wrapper {
    margin: 0;
    max-width: unset;
    width: 100%;

    .inner {
      padding: 5rem 0;
    }
  }

  .title {
    margin-bottom: 1.5rem;
    margin-left: max(0, (100% - 80%) / 2);
    padding-left: 2rem;

    @include sp {
      flex: auto;
      margin: auto;
      max-width: 90%;
      padding: 0;
    }

    h2 {
      color: $black;
      font-size: 2.5em;

      @include sp {
        font-size: 1.75em;
      }
    }
  }

  .text-top {
    display: none;
    font-size: 1em;
    line-height: 2rem;
    margin: 2rem 0;

    @include sp {
      display: block;
      flex: auto;
      margin: 3rem auto;
      max-width: 90%;
      padding: 0;
    }
  }

  .tabs {
    display: flex;
    flex-direction: row;
    margin-left: max(0, (100% - 80%) / 2);
    padding-left: 2rem;

    @include sp {
      flex-direction: column;
      margin-left: 0;
      padding-left: 0;
    }

    /* stylelint-disable no-descending-specificity */
    > div {
      width: 50%;

      @include sp {
        width: 100%;
      }
    }
    /* stylelint-enable no-descending-specificity */

    .img {
      background-color: #f6f9fc;
      margin-left: auto;
      padding-top: 2rem;
      position: relative;

      .img-item {
        height: 0;
        opacity: 0;
        overflow: hidden;
        transition: opacity 0.3s ease-in-out;
        width: 100%;

        @include sp {
          margin-left: auto;
          width: 100%;
        }

        &.active {
          height: auto;
          opacity: 1;
        }
      }

      img {
        height: auto;
        transform: translate3d(0, 0, 0);
        width: 100%;
      }
    }

    .content {
      > .description {
        font-size: 1.2em;
        line-height: 2rem;
      }

      @include sp {
        flex: auto;
        margin: auto;
        max-width: 90%;
        order: 2;
        padding: 0;

        > .description {
          display: none;
        }
      }

      .text {
        color: $black;
        font-size: 1.2em;
        line-height: 2rem;

        @include sp {
          font-size: 1em;
        }
      }

      .list {
        .number {
          align-items: center;
          background-color: #bbb;
          border-radius: 10rem;
          color: $white;
          display: flex;
          font-size: 1.5em;
          font-weight: 600;
          height: 50px;
          justify-content: center;
          margin-right: 1.25rem;
          transition: background-color 0.3s ease-in-out;
          width: 50px;
        }

        > li {
          cursor: pointer;
          display: flex;
          flex-direction: row;
          margin: 3rem 0;
          opacity: 0.8;
          transition: opacity 0.3s ease-in-out;

          &.active {
            opacity: 1;

            .number {
              background-color: #5080c1;
            }
          }
        }

        h3 {
          color: $black;
          font-size: 1.5em;
          font-weight: 600;
          letter-spacing: 1px;
        }

        .heading {
          margin-bottom: 1rem;
        }
      }
    }

    .details {
      margin-left: 1rem;
      width: 80%;
    }
  }
}

.review {
  background-color: #f6f9fc;

  .wrapper {
    flex: auto;
    margin: auto;
    max-width: 80%;
    padding: 0 2rem;
    width: auto;

    @include sp {
      max-width: 90%;
    }

    .inner {
      padding: 5rem 0;
    }
  }

  .title {
    margin-bottom: 1.5rem;
    text-align: center;

    h2 {
      color: $black;
      font-size: 2.5em;

      @include sp {
        font-size: 1.75em;
      }
    }
  }

  .slider {
    @include pc {
      margin: 0 auto;
      max-width: 80%;
    }
  }

  ::v-deep {
    .flicking-arrow-prev,
    .flicking-arrow-next {
      display: flex;
      height: 40px;
      width: 40px;

      &::after,
      &::before {
        content: none;
      }

      &.is-circle {
        background-color: #7baff8;
      }

      svg {
        color: $white;
        display: flex;
        font-size: 1.75em;
        margin: auto;
      }

      @include sp {
        display: none;
      }
    }

    .flicking-pagination {
      margin-top: 1.5rem;
      position: relative;

      @include sp {
        margin-top: 6rem;
      }
    }

    .flicking-pagination-bullet-active {
      background-color: #7baff8;
    }
  }

  .container {
    max-width: none;
    padding: 2rem;
    width: 100%;

    @include sp {
      padding: 1rem 0;
    }

    /* stylelint-disable no-descending-specificity */
    > div {
      background-color: $white;
      border-radius: 1.5rem;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
      padding: 3rem;

      @include sp {
        padding: 2rem 1.5rem;
      }

      .details {
        .header {
          color: $black;
          font-size: 1.5em;
          font-weight: 500;
          line-height: 1.5;
          margin-bottom: 1rem;

          @include sp {
            font-size: 1.25em;
          }
        }

        .text {
          font-size: 1.15em;

          @include sp {
            font-size: 1em;
          }
        }
      }

      .author {
        align-items: center;
        display: flex;
        margin-top: 2rem;

        .logo {
          .img {
            height: 80px;
            width: 80px;

            img {
              border-radius: 50%;
              height: 100%;
              object-fit: cover;
              transform: translate3d(0, 0, 0);
              width: 100%;
            }
          }
        }

        .client {
          margin-left: 1.5rem;

          .name {
            font-size: 1.2em;
            font-weight: 500;
            margin-bottom: 0.25rem;

            @include sp {
              font-size: 1.15em;
            }
          }

          .position {
            font-size: 1.15em;

            @include sp {
              font-size: 1em;
            }
          }
        }
      }
    }
    /* stylelint-enable no-descending-specificity */
  }
}

.faq {
  .wrapper {
    flex: auto;
    margin: auto;
    max-width: 80%;
    padding: 0 2rem;
    width: auto;

    @include sp {
      max-width: 90%;
      padding: 0;
    }

    .inner {
      padding: 5rem 0;
    }
  }

  .title {
    margin-bottom: 1.5rem;

    h2 {
      color: $black;
      font-size: 2em;

      @include sp {
        font-size: 1.85em;
      }
    }
  }

  ::v-deep {
    .accordion {
      .main {
        border-bottom: 1px solid #c3c3c3;

        &:last-child {
          border: 0;
        }

        .title {
          display: flex;
          justify-content: space-between;
          margin: 0;
          padding: 1.95rem 0;

          h3 {
            color: $black;
            font-weight: 500;
          }

          .button {
            i {
              color: #5080c1;
              font-size: 1.5em;
              transition: transform 0.3s ease-in-out;
            }
          }

          &.active {
            padding-bottom: 0.75rem;

            .button {
              i {
                transform: rotate(-135deg);
              }
            }
          }
        }

        .content {
          height: 0;
          opacity: 0;
          overflow: hidden;
          transition: height 0.3s ease-in-out, opacity 0.3s ease-in-out;

          p {
            padding-bottom: 1rem;
            padding-right: 1.5rem;
          }

          &.active {
            height: auto;
            opacity: 1;
          }
        }
      }
    }

    .ui.accordion {
      .title ~ .content {
        display: block;
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .banner {
    h1 {
      font-size: 3.5rem;
    }

    .left {
      .details {
        p {
          font-size: 1rem;
        }
      }

      .btn-group {
        a {
          margin: auto;
          padding: 1.25rem 1.5rem;
          width: 15rem;
        }
      }
    }
  }

  .steps {
    .main {
      .list {
        > li {
          &::after {
            right: -1.5rem;
            top: 4rem;
          }
        }

        .icon {
          height: 130px;
          width: 130px;
        }
      }
    }
  }

  .review {
    .container {
      .details {
        margin-left: 5rem;
      }

      .author {
        margin-left: 5rem;
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .banner {
    h1 {
      font-size: 2.85rem;
    }
  }
}

@media screen and (max-width: 991px) {
  .banner {
    flex-direction: column;
    padding-top: 10rem;

    .left,
    .right {
      width: 100%;
    }

    .left {
      order: 2;

      .caption {
        padding: 1.5rem 1rem;
      }

      .btn-group {
        display: block;
        width: 100%;

        a {
          width: 100%;

          &.looking-for-talent {
            margin-left: 0;
            margin-top: 1rem;
          }
        }
      }
    }
  }

  .review {
    .container {
      .details {
        margin-left: 0;
      }

      .author {
        margin-left: 0;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .steps {
    .main {
      .list {
        flex-direction: column;

        .content {
          padding-bottom: 3rem;
          position: relative;
          width: 60%;

          &::after {
            bottom: 0;
            color: #7b95df;
            content: '\f0da';
            font-family: 'Font Awesome 5 Free', sans-serif;
            font-size: 2.5em;
            font-style: normal;
            font-weight: 900;
            left: 0;
            position: absolute;
            transform: rotate(90deg);
          }
        }

        > li {
          display: flex;
          justify-content: space-between;
          margin-bottom: 2.5rem;
          width: 100%;

          &::after {
            content: none;
          }

          &:last-child {
            margin-bottom: 0;

            .content {
              &::after {
                content: none;
              }
            }
          }
        }

        .icon {
          height: 150px;
          width: 150px;
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .banner {
    .right {
      .img {
        height: 350px;
      }
    }
  }

  .choose-sourcedout {
    .main {
      .list {
        .icon {
          img {
            height: 60px;
            width: 60px;
          }
        }
      }
    }
  }

  .steps {
    .main {
      .list {
        .icon {
          height: 130px;
          width: 130px;
        }

        .content {
          width: 50%;

          &::after {
            left: 3px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 320px) {
  .banner {
    h1 {
      font-size: 1.85em;
    }
  }
}

/* stylelint-disable  no-descending-specificity */
:lang(th) {
  .faq {
    ::v-deep {
      .accordion {
        .main {
          h3 {
            font-size: 1.2em;
          }
        }
      }
    }
  }
}
/* stylelint-enable  no-descending-specificity */
</style>
